var map = {
	"./amex.png": 1037,
	"./diners.png": 1038,
	"./discover.png": 1039,
	"./jcb.png": 1040,
	"./maestro.png": 1269,
	"./mastercard.png": 1041,
	"./stripe.png": 1042,
	"./union.png": 1043,
	"./unknown.png": 719,
	"./visa.png": 1044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1268;